<template>

    <div class="y-practice">

        <div :class="['y-practice__select', {'has-danger': errors.has('tutor', 'st_pr')}]">

            <div class="y-practice__select-label">{{ $t('Tutor') }}</div>

            <multiselect
                    class="y-practice__multiselect"
                    v-model="tutor"
                    placeholder="Виберіть тьютора"
                    :options="tutors"
                    label="full_name"
                    track-by="id"
                    @input="getShedule()"
                    @close="getAbsents()"
            />

            <div v-if="errors.has('tutor', 'st_pr')" v-cloak
                     class="y-error y-practice__select-error">{{ errors.has('tutor', 'st_pr') }}
            </div>

        </div>

        <template v-if="tutor && absents" ref="salary">

            <div class="y-practice__inf">

                <div class="y-practice__heading">{{ $t('You_make_missed_classes') }}</div>

                <div v-for="program in absents.counts" class="y-practice__program">

                    <div class="y-practice__program-name">{{ program.name }}:</div>
                    <div class="y-practice__program-count">{{ program.count }}</div>

                </div>

            </div>

            <div class="y-practice__content">

                <div class="y-practice__row sticky-top" style="--sticky_top: 3px">

                    <div class="y-practice__datetime" data-datetime>
                        <div class="y-practice__datetime-txt">{{ datetimeHeader }}</div>
                        <div class="y-practice__datetime-icn">
                            <svg width="17" height="18" viewBox="0 0 17 18" style="fill:none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="1" y="2.23096" width="14.7692" height="14.7692" rx="2" stroke="#1E1E20" stroke-width="1.5" />
                                <path d="M1 6.33311H15.7692" stroke="#1E1E20" stroke-width="1.5" stroke-linejoin="round" />
                                <path d="M12.077 1L12.077 3.46154" stroke="#1E1E20" stroke-width="1.5" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                <path d="M4.69224 1L4.69224 3.46154" stroke="#1E1E20" stroke-width="1.5" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                <path d="M3.87183 9.61513H4.69234" stroke="#1E1E20" stroke-width="1.5" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                <path d="M7.97437 9.61513H8.79488" stroke="#1E1E20" stroke-width="1.5" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                <path d="M12.0769 9.61513H12.8974" stroke="#1E1E20" stroke-width="1.5" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                <path d="M3.87183 12.8974H4.69234" stroke="#1E1E20" stroke-width="1.5" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                <path d="M7.97437 12.8974H8.79488" stroke="#1E1E20" stroke-width="1.5" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                <path d="M12.0769 12.8974H12.8974" stroke="#1E1E20" stroke-width="1.5" stroke-linecap="round"
                                            stroke-linejoin="round" />
                            </svg>
                        </div>

                        <datetime
                                v-model="week"
                                :config="datetimePickerConfig"
                                class="flatpickr y-practice__flatpickr"
                                placeholder="Select data"
                        />
                    </div>

                    <div :class="[ 'y-practice__choose', { 'is_error': showError }]" v-if="showError">
                        <div class="y-practice__choose-error" v-for="error in errors.all('st_pr')">{{ error }}</div>
                    </div>
                    <div v-else></div>

                    <button
                            type="button"
                            :disabled="BtnDisabled"
                            :data-modal-init="!BtnDisabled ? 'record' : null"
                            @click="addStudentPeriods"
                            class="y-btn y-btn_main y-practice__btn-main"
                    >
                        <span class="y-btn__txt">{{ $t('Book_up_lesson') }}</span>
                    </button>

                </div>

                <div class="y-practice-table y-practice__table">

                    <div class="y-practice-table__th">
                        <div class="y-practice-table__td"></div>

                        <div v-for="day in periods.days" class="y-practice-table__td">
                            <div class="y-practice-table__week-day">{{ day.week_day_name }}</div>
                            <div class="y-practice-table__day">{{ day.date.split('/')[0] }}</div>
                        </div>

                    </div>

                    <div v-for="(time, index) in periods.table" class="y-practice-table__tr">

                        <div class="y-practice-table__td">
                            <div class="y-practice-table__time">{{ index }}</div>
                        </div>

                        <template v-for="(item, date) in time">

                            <div
                                    v-if="choose_data.some(item => item.day === date && item.start === index)"
                                    @click="deletePeriod(date, index, item)"
                                    class="y-practice-table__td is_chose"
                                    :style="[ item.status !== 4 ? {'cursor': 'pointer'} : '', item.color !== '' ? { 'background-color': `var(--practice_td_bgc, ${ item.color })` } : '']"
                                    :title="item.status ? item.value : null "
                            >
                                <span class="y-practice-table__td-value">{{item.value}}</span>
                            </div>

                            <div
                                    v-else
                                    @click="chosePeriod(date, index, item)"
                                    :data-modal-init="item.status === 2 && AddClassChoose ? 'reserved' : null"
                                    :class="[ 'y-practice-table__td', { 'is_free': item.status === 1 }]"
                                    :style="[ item.status !== 4 ? {'cursor': 'pointer'} : '', item.color !== '' ? { 'background-color': `var(--practice_td_bgc, ${ item.color })` } : '']"
                                    :title="item.status ? item.value : null"
                            >
                                <span class="y-practice-table__td-value">{{item.value}}</span>
                            </div>
                        </template>

                    </div>

                </div>

            </div>

        </template>

        <div class="gradebook__main">
            <div class="spiner_gradebook" v-if="submiting"
                     style="width:100%; display:flex; justify-content: center; align-items: center;">
                <img src="/img/spiner.gif" alt="spiner" width="150" height="auto" style="object-fit: contain">
            </div>
        </div>

        <div
                class="y-modal is_reserved y-practice__modal-reserved"
                data-modal="reserved"
                v-if="student_modal"
        >
            <div class="y-modal__inner">
                <div class="y-modal__header">
                    <div class="y-modal__title">
                        {{ $t('Lesson') }}
                        <template v-if="student_modal.status === 4">
                            {{ $t('worked') }}
                        </template>
                        <template v-if="student_modal.status === 2">
                            {{ $t('Booked') }}
                        </template>
                    </div>
                    <button
                            data-modal-close
                            class="is_reserved y-btn y-modal__btn-close"
                            aria-label="close modal record"
                    >
                        <span class="y-btn__icn"></span>
                        <span class="y-btn__txt">{{ $t('Close') }}</span>
                    </button>
                </div>
                <div class="y-modal__main" data-scroll-check>
                    <div class="y-modal__main-inner" data-scroll-inner>

                        <div class="y-record">

                            <div class="y-record__row">
                                <div class="y-record__key">{{ $t('Group') }}</div>
                                <div class="y-record__val">{{ group.name }}</div>
                            </div>

                            <div class="y-record__row" v-if="student_modal.period.type">
                                <div class="y-record__key">{{ $t('Format') }}</div>
                                <div class="y-record__val">{{ student_modal.period.type }}</div>
                            </div>

                            <div class="y-record__row" v-if="student_modal.period.link">
                                <div class="y-record__key">{{ $t('Link_making_lesson') }}</div>
                                <a :href="student_modal.period.link" class="y-record__val">{{ student_modal.period.link }}</a>
                            </div>

                            <div class="y-record__row" v-if="student_modal.period.lesson">
                                <div class="y-record__key">{{ $t('Lesson') }}</div>
                                <div class="y-record__val">{{ student_modal.period.lesson.name }}</div>
                            </div>

                            <div class="y-record__row" v-if="student_modal.period.comment">
                                <div class="y-record__key">{{ $t('Comment') }}</div>
                                <div class="y-record__val">{{ student_modal.period.comment }}</div>
                            </div>

                            <div class="y-record__row" v-if="student_modal.period.phone">
                                <div class="y-record__key">{{ $t('Phone') }}</div>
                                <div class="y-record__val">{{ student_modal.period.phone }}</div>
                            </div>

                        </div>

                    </div>
                </div>
                <div class="y-modal__footer">
                    <div v-if="student_modal.status === 2"
                             class="elms jcsb cg-10"
                    >
                        <button
                                type="button"
                                :disabled="submiting"
                                @click="deleteExistingPeriod(student_modal)"
                                class="y-btn y-btn_main y-record__btn-main"
                        >
                            <span class="y-btn__txt">{{ $t('Cancel_your_booking') }}</span>
                        </button>
                        <button
                                type="button"
                                data-modal-close
                                class="is_reserved y-btn y-btn_default y-record__btn-default"
                        >
                            <span class="y-btn__icn">{{ $t('Close') }}</span>
                        </button>
                    </div>

                    <div v-else class="elms jcfe cg-10">
                        <button
                                type="button"
                                data-modal-close
                                :disabled="submiting"
                                class="is_reserved y-btn y-btn_default y-record__btn-default"
                        >
                            <span class="y-btn__icn">{{ $t('Good') }}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>


        <student-practice-add-period-modal
                v-if="show_modal_add_period"
                ref="addStudentPeriods"
                :data_cells="choose_data"
                :data_absents="absents"
                @closePracticeModal="closePracticeModal"
        />


        <notifications position="bottom right" />
    </div>

</template>


<script>

import axios from "axios";

export default {
    name: "StudentPractice",
    props: [
        'student_data',
        'tutor_data',
        'tutors_data',
        'periods_data',
        'start_current_week',
        'academy_data',
        'group_data',
        'practice_schedule_data'
    ],
    data() {
        return {
            submiting: false,
            show_modal_add_period: false,
            showError: false,
            student_modal: null,
            practice_schedule: false,
            student: null,
            absents: null,
            periods: null,
            academy: null,
            group: null,
            tutor: null,
            tutors: [],
            week: null,
            datetimeHeader: '',
            table: null,
            days: null,
            choose_data: [],
            BtnDisabled: true,
            AddClassChoose: false,
            datetimePickerConfig: {
                static: true,
                enableMonth: true,
                altFormat: "Y-m-d",
                dateFormat: "Y-m-d",
                locale: {
                    firstDayOfWeek: 1,
                    // weekdays: {
                    //  shorthand: [ 'Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa' ],
                    //  longhand: [ 'Вівторок', 'Середа', 'Четвер', "'П'ятниця'", 'Субота', 'Неділя', 'Понеділок' ],
                    // },
                    // months: {
                    //  shorthand: [ 'Jan', 'Feb', 'March', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec' ],
                    //  longhand: [ 'Січень', 'Лютий', 'Березень', 'Квітень', 'Травень', 'Червень', 'Липень', 'Серпень', 'Вересень', 'Жовтень', 'Листопад', 'Грудень' ],
                    // },
                },

                nextArrow: '<svg width="25" height="24" viewBox="0 0 25 24" style="fill:none" xmlns="http://www.w3.org/2000/svg"><path d="M16.5 16L19.7929 12.7071C20.1834 12.3166 20.1834 11.6834 19.7929 11.2929L16.5 8" stroke="#6A6A6A" stroke-width="1.5" stroke-linecap="round"/><path d="M19.5 12L5.5 12" stroke="#6A6A6A" stroke-width="1.5" stroke-linecap="round"/></svg>',
                prevArrow: '<svg width="24" height="24" viewBox="0 0 24 24" style="fill:none" xmlns="http://www.w3.org/2000/svg"><path d="M8 8L4.70711 11.2929C4.31658 11.6834 4.31658 12.3166 4.70711 12.7071L8 16" stroke="#6A6A6A" stroke-width="1.5" stroke-linecap="round"/><path d="M5 12L19 12" stroke="#6A6A6A" stroke-width="1.5" stroke-linecap="round"/></svg>',

                disable: [
                    function (date) {
                        return ([ 0, 2, 3, 4, 5, 6 ].includes(date.getDay()));
                    }
                ],
                onClose: (selectedDates, dateStr, instance) => {
                    this.getShedule(instance);
                },
            },
        }
    },
    async created() {
        if (!this.$parent.initedLocale) {
            this.$parent.initedLocale = true;
            const { data: { locale } } = await axios.get('/locale/language');
            this.$i18n.locale = locale || (process.env.MIX_APP_LOCALE !== undefined
                ? process.env.MIX_APP_LOCALE : 'ua')
            ;
        }

        this.datetimePickerConfig.locale.weekdays = {
            shorthand: [this.$t('Su'), this.$t('Mo'), this.$t('Tu'), this.$t('We'), this.$t('Th'), this.$t('Fr'), this.$t('Sa')],
            longhand: [this.$t('Sunday'), this.$t('Monday'), this.$t('Tuesday'), this.$t('Wednesday'), this.$t('Thursday'), this.$t('Friday'), this.$t('Saturday')],
        };

        this.datetimePickerConfig.locale.months = {
            shorthand: [this.$t('Jan'), this.$t('Feb'), this.$t('March'), this.$t('Apr'), this.$t('May'), this.$t('June'), this.$t('July'), this.$t('Aug'), this.$t('Sept'), this.$t('Oct'), this.$t('Nov'), this.$t('Dec') ],
            longhand: [this.$t('January'), this.$t('February'), this.$t('March'), this.$t('April'), this.$t('May'), this.$t('June'), this.$t('July'), this.$t('August'), this.$t('September'), this.$t('October'), this.$t('November'), this.$t('December')],
        };
    },
    mounted() {
        this.student = this.student_data;
        this.tutors = this.tutors_data;
        this.practice_schedule = this.practice_schedule_data;
        if (this.practice_schedule) {
            _.forEach(this.tutors, (tutor) => {
                if (tutor.id === this.practice_schedule.tutor_id) {
                    this.tutor = tutor;
                    setTimeout(() => {
                        this.getShedule();
                        this.getAbsents();
                    }, 200)
                }
            })
        }
        this.group = this.group_data;
        this.academy = this.academy_data;
        this.periods = this.periods_data;
        this.week = this.start_current_week;

        $(document).on('click', '[data-modal-close].is_reserved', () => {
            $(`[data-modal]`).on('transitionend webkitTransitionEnd oTransitionEnd', () => {
                $('[data-overlay]').on('transitionend webkitTransitionEnd oTransitionEnd', () => {
                    this.student_modal = null
                    this.AddClassChoose = false
                    $(`[data-modal].is_reserved`).off('transitionend webkitTransitionEnd oTransitionEnd')
                })
            })
        })

    },
    methods: {
        openModal(period) {
            this.student_modal = null;
            this.errors.clear('st_pr');
            this.student_modal = period;
        },
        closeModal() {
            // setTimeout(() => {
            //  this.student_modal = null
            //  this.AddClassChoose = false
            // },1500)
        },
        closePracticeModal() {
            this.BtnDisabled = true
            this.AddClassChoose = false
        },
        chosePeriod(day, time, period) {
            this.showError = false;
            this.errors.clear('st_pr');
            if (period.status === 1) {
                this.addPeriodToChooseData(day, time);
            } else if (period.status === 2 || period.status === 4) {
                this.openModal(period);
            }
            if (period.status === 2 && period) {
                this.AddClassChoose = true
            }
        },
        addPeriodToChooseData(day, time) {
            if (this.choose_data.length === this.absents.total_counts) {
                this.errors.add({
                    field: 'max_cell_day',
                    msg: this.$t('no_more_classes_left'),
                    scope: 'st_pr'
                });
                this.showError = true;
            } else {
                let end = this.getEndPeriod(time);
                let count = 0;
                _.forEach(this.periods.table, (t) => {
                    _.forEach(t, (item, index) => {
                        if (item.status === 2 && index === day) {
                            count++;
                        }
                    });
                });
                if (count >= 4) {
                    this.errors.add({
                        field: 'max_cell_day',
                        msg: 'Ви не маєте можливості відпрацювати більше 4-х уроків за один день',
                        scope: 'st_pr'
                    });
                    this.showError = true;
                } else {
                    if (this.choose_data.length < 4) {
                        this.BtnDisabled = false
                        this.choose_data.push({ day: day, start: time, end: end });
                    } else {
                        this.errors.add({
                            field: 'max_cell',
                            msg: 'Ви не маєте можливості вибрати більше 4-х слотів',
                            scope: 'st_pr'
                        });
                        this.showError = true;
                    }
                }
            }
        },
        async deleteExistingPeriod(period) {
            this.submiting = true;
            try {
                await axios.post('/student/dashboard/practice/deleteExistingPeriod', period);
                this.$notify({
                    type: 'success',
                    title: this.$t('Successfully'),
                    text: this.$t('Period_successfully_removed'),
                    duration: 5000
                });

                setTimeout(() => {
                    this.student_modal = null;
                    this.AddClassChoose = false;
                    this.BtnDisabled = true;
                }, 1500)

                $('[data-modal-close]').trigger('click')

                this.getShedule();
                this.getAbsents();
            } catch (error) {
                this.errors.clear('st_pr')
                let errors = error.response.data.errors;
                for (const prop in errors) {
                    this.errors.add({ field: prop, msg: errors[prop][0], scope: 'st_pr' });
                }
                this.submiting = false;
            }
            this.submiting = false;
        },
        deletePeriod(day, time, item) {
            if (item.status === 1) {
                this.choose_data.forEach((item, index) => {
                    if (item.day === day && item.start === time) {
                        this.choose_data.splice(index, 1);
                        if (this.choose_data.length === 0) {
                            this.BtnDisabled = true
                        }
                    }
                })
            }
        },
        getEndPeriod(start) {
            const myarr = start.split(":");
            let end;
            const hour = parseInt(myarr[0]);
            if (myarr[1] === "20") {
                end = [ hour, "40" ].join(':')
            } else if (myarr[1] === "00") {
                end = [ hour, "20" ].join(':')
            } else {
                end = [ hour + 1, "00" ].join(':')
            }
            return end;
        },
        forceUpdate() {
            this.$forceUpdate();
        },
        async getShedule(instance = null) {
            const week = instance ? instance.formatDate(instance.latestSelectedDateObj, "Y-m-d") : this.week;
            this.submiting = true;
            let post_data = {
                week: week,
                academy_id: this.academy.id,
                practice_schedule: this.practice_schedule,
                tutor_id: this.tutor.id
            };

            const currentWeek = new Date(week)
            const month = this.$t(new Intl.DateTimeFormat('en-US', { month: 'long' }).format(currentWeek))
            const startWeek = new Intl.DateTimeFormat('uk-UA', { day: 'numeric' }).format(currentWeek)
            const endWeek = new Intl.DateTimeFormat('uk-UA', { day: 'numeric' }).format(currentWeek.setDate(currentWeek.getDate() + 6))
            const year = new Intl.DateTimeFormat('uk-UA', { year: 'numeric' }).format(currentWeek)

            this.datetimeHeader = `${ month[0].toUpperCase() + month.slice(1) } ${ startWeek < 10 ? 0 + startWeek : startWeek }-${ endWeek < 10 ? 0 + endWeek : endWeek }, ${ year }`

            try {
                const { data: { periods } } = await axios.post('/student/dashboard/practice/getShedule', post_data);
                this.periods = periods;
                if (this.periods.active_modal) {
                    this.openModal(this.periods.active_modal);
                }
                this.practice_schedule = false;
                window.history.replaceState({}, document.title, '/student/dashboard/practice');
            } catch (error) {
                this.errors.clear('st_pr');
                let errors = error.response.data.errors;
                for (const prop in errors) {
                    this.errors.add({ field: prop, msg: errors[prop][0], scope: 'st_pr' });
                }
            }
            this.submiting = false;
        },
        async getAbsents() {
            this.submiting = true;
            let post_data = {
                student_id: this.student.id,
                tutor_id: this.tutor.id,
            };
            const { data: { absents } } = await axios.post('/student/dashboard/practice/getAbsents', post_data);
            this.absents = absents;
            this.submiting = false;
        },
        addStudentPeriods() {
            this.showError = false;
            this.errors.remove('required_cell', 'st_pr')
            if (this.choose_data.length) {
                this.show_modal_add_period = true;
            } else {
                this.errors.add({ field: 'required_cell', msg: this.$t('Select_least_time'), scope: 'st_pr' });
                this.showError = true;
            }
        }
    }
}
</script>
